<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama, email, atau username&hellip;"
                 aria-label="Cari pengguna" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter cara masuk"
                  (change)="isVia = $event.target.value; applyFilter()">
            <option value="">Semua via</option>
            <option value="google">Google</option>
            <option value="facebook">Facebook</option>
            <option value="apple">Apple</option>
            <option value="manual">Manual</option>
          </select>
          <select class="vl-select" aria-label="Filter langganan"
                  (change)="isSubsFilter = $event.target.value; applyFilter()">
            <option value="">Semua langganan</option>
            <option value="1">Berlangganan</option>
            <option value="0">Tidak berlangganan</option>
          </select>
          <select class="vl-select" aria-label="Filter status"
                  (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="1">Aktif</option>
            <option value="0">Banned</option>
            <option value="2">Dihapus</option>
          </select>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Pengguna</th>
                  <th>Username</th>
                  <th>Masuk via</th>
                  <th>Langganan</th>
                  <th>Terakhir Login</th>
                  <th>Status</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row vu-rowlink" [class.vl-alt]="i % 2 == 1"
                    (click)="openDetail(v)">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td>
                    <div class="vu-ident">
                      <img [src]="v.photoUrl" alt="{{v.name}}" class="vu-avatar vb-click" title="Lihat foto"
                           (click)="openViewer(v.photoUrl); $event.stopPropagation()"
                           onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
                      <div class="vu-ident-text">
                        <span class="vl-name" [innerHTML]="highlight(v.name)"></span>
                        <span class="vu-email" [innerHTML]="highlight(v.email)"></span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span *ngIf="v.username" class="vl-muted" [innerHTML]="highlight(v.username)"></span>
                    <span *ngIf="!v.username" class="vl-muted">&mdash;</span>
                  </td>
                  <td>
                    <span *ngIf="v.sign_with == 'google'" class="vl-tag provider">
                      <svg viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                      Google</span>
                    <span *ngIf="v.sign_with == 'facebook'" class="vl-tag provider">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877F2" d="M24 12a12 12 0 10-13.88 11.85v-8.38H7.08V12h3.04V9.36c0-3 1.79-4.67 4.53-4.67 1.31 0 2.68.24 2.68.24v2.95h-1.51c-1.49 0-1.95.92-1.95 1.87V12h3.32l-.53 3.47h-2.79v8.38A12 12 0 0024 12z"/></svg>
                      Facebook</span>
                    <span *ngIf="v.sign_with == 'apple'" class="vl-tag provider">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#111" d="M16.36 12.76c-.02-2.22 1.81-3.28 1.89-3.33-1.03-1.5-2.63-1.71-3.2-1.73-1.36-.14-2.66.8-3.35.8-.69 0-1.76-.78-2.89-.76-1.49.02-2.86.86-3.62 2.19-1.55 2.68-.4 6.64 1.11 8.81.74 1.06 1.61 2.26 2.76 2.22 1.11-.05 1.53-.72 2.87-.72 1.34 0 1.72.72 2.89.7 1.2-.02 1.95-1.08 2.68-2.15.85-1.23 1.19-2.42 1.21-2.48-.03-.01-2.32-.89-2.35-3.55zM14.16 5.83c.61-.74 1.02-1.77.91-2.8-.88.04-1.94.59-2.57 1.32-.56.65-1.06 1.7-.93 2.7.98.08 1.98-.5 2.59-1.22z"/></svg>
                      Apple</span>
                    <span *ngIf="!v.sign_with" class="vl-tag provider">Manual</span>
                  </td>
                  <td>
                    <span *ngIf="v.is_subscribed == 1" class="vl-pill subs"><span class="vl-dot"></span>Berlangganan</span>
                    <span *ngIf="v.is_subscribed != 1" class="vl-muted">&mdash;</span>
                  </td>
                  <td class="vl-muted vl-small">{{v.lastSignVw}}</td>
                  <td>
                    <span *ngIf="v.status == 1" class="vl-pill on"><span class="vl-dot"></span>Aktif</span>
                    <span *ngIf="v.status == 0" class="vl-pill ban"><span class="vl-dot"></span>Banned</span>
                    <span *ngIf="v.status == 2" class="vl-pill off"><span class="vl-dot"></span>Dihapus</span>
                  </td>
                  <td>
                    <div class="vl-actions">
                      <button type="button" class="vl-icon" title="Detail pengguna" (click)="openDetail(v)">
                        <i class="fa fa-eye"></i></button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="8" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> pengguna</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- detail dialog: full profile + status control -->
<div class="hds-overlay" *ngIf="isDetail" (click)="closeDetail()">
  <div class="hds-dialog vu-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <button type="button" class="vu-close" title="Tutup" aria-label="Tutup"
            [disabled]="isSaving" (click)="closeDetail()">&times;</button>
    <div class="vu-head">
      <img [src]="isDetail.photoUrl" alt="{{isDetail.name}}" class="vu-avatar-lg vb-click" title="Lihat foto"
           (click)="openViewer(isDetail.photoUrl)"
           onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
      <div class="vu-head-text">
        <h3>{{isDetail.name}}</h3>
        <div class="vu-head-mail">{{isDetail.email}}</div>
        <span *ngIf="isDetail.sign_with == 'google'" class="vl-tag provider">
          <svg viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Google</span>
        <span *ngIf="isDetail.sign_with == 'facebook'" class="vl-tag provider">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877F2" d="M24 12a12 12 0 10-13.88 11.85v-8.38H7.08V12h3.04V9.36c0-3 1.79-4.67 4.53-4.67 1.31 0 2.68.24 2.68.24v2.95h-1.51c-1.49 0-1.95.92-1.95 1.87V12h3.32l-.53 3.47h-2.79v8.38A12 12 0 0024 12z"/></svg>
          Facebook</span>
        <span *ngIf="isDetail.sign_with == 'apple'" class="vl-tag provider">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#111" d="M16.36 12.76c-.02-2.22 1.81-3.28 1.89-3.33-1.03-1.5-2.63-1.71-3.2-1.73-1.36-.14-2.66.8-3.35.8-.69 0-1.76-.78-2.89-.76-1.49.02-2.86.86-3.62 2.19-1.55 2.68-.4 6.64 1.11 8.81.74 1.06 1.61 2.26 2.76 2.22 1.11-.05 1.53-.72 2.87-.72 1.34 0 1.72.72 2.89.7 1.2-.02 1.95-1.08 2.68-2.15.85-1.23 1.19-2.42 1.21-2.48-.03-.01-2.32-.89-2.35-3.55zM14.16 5.83c.61-.74 1.02-1.77.91-2.8-.88.04-1.94.59-2.57 1.32-.56.65-1.06 1.7-.93 2.7.98.08 1.98-.5 2.59-1.22z"/></svg>
          Apple</span>
        <span *ngIf="!isDetail.sign_with" class="vl-tag provider">Manual</span>
      </div>
    </div>

    <div class="vu-body">
      <div class="vu-grid">
        <div class="vu-cell">
          <span class="vu-label">Username</span>
          <span>{{dash(isDetail.username)}}</span>
        </div>
        <div class="vu-cell">
          <span class="vu-label">Verifikasi Email</span>
          <span *ngIf="isDetail.is_verification == 1" class="vl-pill on"><span class="vl-dot"></span>Sudah</span>
          <span *ngIf="isDetail.is_verification != 1" class="vl-pill off"><span class="vl-dot"></span>Belum</span>
        </div>
        <div class="vu-cell">
          <span class="vu-label">Nomor Handphone</span>
          <span *ngIf="isSubs === null" class="vu-subs-wait">Memuat&hellip;</span>
          <span *ngIf="isSubs !== null">{{dash(isDetail.phone_number)}}</span>
        </div>
        <div class="vu-cell">
          <span class="vu-label">Tanggal Lahir</span>
          <span>{{isDetail.birthDateVw}}</span>
        </div>
        <div class="vu-cell">
          <span class="vu-label">Jenis Kelamin</span>
          <span>{{dash(isDetail.gender)}}</span>
        </div>
        <div class="vu-cell">
          <span class="vu-label">Terakhir Login</span>
          <span>{{isDetail.lastSignVw}}</span>
        </div>
      </div>

      <!-- latest device/app/region from the app's request headers (90-day log) -->
      <div class="vu-status" *ngIf="isUsage">
        <span class="vu-label">Perangkat Terakhir</span>
        <div class="vu-grid">
          <div class="vu-cell">
            <span class="vu-label">Perangkat</span>
            <span>{{isUsage.device}}</span>
          </div>
          <div class="vu-cell">
            <span class="vu-label">Versi Aplikasi</span>
            <span>{{isUsage.version}}</span>
          </div>
          <div class="vu-cell">
            <span class="vu-label">Wilayah</span>
            <span>{{isUsage.region}}
              <a *ngIf="isUsage.mapUrl" [href]="isUsage.mapUrl" target="_blank" rel="noopener" title="Lihat di peta (±100 m)">
                <i class="fa fa-map-marker"></i></a></span>
          </div>
          <div class="vu-cell">
            <span class="vu-label">Terakhir Aktif</span>
            <span>{{isUsage.lastSeen}} &middot; {{isUsage.activeDays}} hari aktif (30 hari)</span>
          </div>
        </div>
      </div>

      <!-- subscription: state on the left, the attach action on the right -->
      <div class="vu-status">
        <span class="vu-label">Langganan</span>
        <div class="vu-subrow">
          <span *ngIf="isSubs === null" class="vu-subs-wait">Memuat&hellip;</span>
          <span *ngIf="isSubs && isSubs.failed" class="vu-subs-wait">Gagal memuat</span>
          <ng-container *ngIf="isSubs && !isSubs.failed">
            <span *ngIf="isSubs.active" class="vl-pill subs"><span class="vl-dot"></span>Berlangganan</span>
            <span *ngIf="!isSubs.active" class="vl-pill off"><span class="vl-dot"></span>Tidak berlangganan</span>
            <span class="vu-subs-note" *ngIf="isSubs.note">{{isSubs.note}}</span>
            <span class="vu-sp"></span>
            <button type="button" class="vu-grant-btn" *ngIf="!isSubs.active && canEditStatus()" (click)="openGrant()">
              <i class="fa fa-link"></i> Pasangkan Voucher</button>
          </ng-container>
        </div>
        <div class="vu-subrow" *ngIf="isSubs && !isSubs.failed && canEditStatus()">
          <button type="button" class="vu-grant-btn" *ngIf="!isSubs.active" (click)="openPremiumGrant()">
            <i class="fa fa-gift"></i> Beri Premium Manual</button>
          <ng-container *ngIf="isSubs.active">
            <button type="button" class="vu-grant-btn" (click)="openPremiumExtend()">
              <i class="fa fa-clock-o"></i> Perpanjang</button>
            <button type="button" class="vu-grant-btn vu-revoke-btn" (click)="openPremiumRevoke()">
              <i class="fa fa-ban"></i> Cabut Premium</button>
          </ng-container>
        </div>
      </div>

      <div class="vu-status">
        <span class="vu-label">Status Akun</span>
        <div class="vu-seg" *ngIf="canEditStatus()">
          <button type="button" [class.on]="isNewStatus == '1'" (click)="onStatusPick('1')">Aktif</button>
          <button type="button" [class.ban]="isNewStatus == '0'" (click)="onStatusPick('0')">Banned</button>
        </div>
        <div class="vu-hint" *ngIf="canEditStatus()">
          Pengguna berstatus Banned tidak bisa masuk ke aplikasi.
        </div>
        <div class="vu-deleted" *ngIf="!canEditStatus()">
          <span class="vl-pill off"><span class="vl-dot"></span>Dihapus</span>
          <span class="vu-hint">Akun ini sudah dihapus &mdash; statusnya tidak bisa diubah lagi.</span>
          <span class="vu-hint" *ngIf="isWipe">{{isWipe}}</span>
        </div>
      </div>

      <!-- password reset (any non-deleted account) -->
      <div class="vu-status" *ngIf="canEditStatus()">
        <span class="vu-label">Password</span>
        <div class="vu-reset">
          <button type="button" class="vl-btn-ghost vu-reset-btn" [disabled]="isSaving" (click)="askResetPassword()">
            <i class="fa fa-key"></i> Reset Password</button>
          <span class="vu-hint">Setel ulang ke password default.</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- confirmation (status change / password reset) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">

    <ng-container *ngIf="isConfirm.mode == 'status'">
      <div class="hds-b">
        <h3>Ubah status pengguna?</h3>
        <p class="hds-sub">Periksa kembali sebelum menyimpan.</p>
        <div class="hds-panel">
          <div class="hds-row"><span>Pengguna</span><b>{{isConfirm.v.name}}</b></div>
          <div class="hds-row"><span>Status</span>
            <b>{{statusLabel(isConfirm.from)}} &rarr; {{statusLabel(isConfirm.to)}}</b></div>
        </div>
        <div class="hds-warn" *ngIf="isConfirm.to == '0'">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0zM12 9v4M12 17h.01"/></svg>
          <span>Pengguna tidak akan bisa masuk ke aplikasi selama status Banned.</span>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeConfirm()">Batal</button>
        <button type="button" [ngClass]="isConfirm.to == '0' ? 'hds-btn-danger' : 'vl-btn-primary'"
                [disabled]="isSaving" (click)="confirmStatus()">
          <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i>
          {{isConfirm.to == '0' ? 'Ya, Banned Pengguna' : 'Ya, Aktifkan'}}</button>
      </div>
    </ng-container>

    <ng-container *ngIf="isConfirm.mode == 'password'">
      <div class="hds-b">
        <h3>Reset password pengguna?</h3>
        <p class="hds-sub">Periksa kembali sebelum mereset.</p>
        <div class="hds-panel">
          <div class="hds-row"><span>Pengguna</span><b>{{isConfirm.v.name}}</b></div>
          <div class="hds-row"><span>Password baru</span>
            <b class="vu-pass-wrap"><code class="vu-pass">hatam165</code>
              <button type="button" class="vl-copy" title="Salin password" (click)="copyText('hatam165')">
                <i class="fa fa-copy"></i></button></b></div>
        </div>
        <div class="hds-warn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0zM12 9v4M12 17h.01"/></svg>
          <span>Password lama langsung tidak berlaku &mdash; sampaikan password baru ini ke pengguna.</span>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeConfirm()">Batal</button>
        <button type="button" class="vl-btn-primary" [disabled]="isSaving" (click)="confirmReset()">
          <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i> Ya, Reset Password</button>
      </div>
    </ng-container>

    <ng-container *ngIf="isConfirm.mode == 'revoke'">
      <div class="hds-b">
        <h3>Cabut premium pengguna ini?</h3>
        <p class="hds-sub">Langganan aktifnya akan langsung dianggap berakhir.</p>
        <div class="hds-panel">
          <div class="hds-row"><span>Pengguna</span><b>{{isConfirm.v.name}}</b></div>
        </div>
        <div class="hds-warn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0zM12 9v4M12 17h.01"/></svg>
          <span>Berlaku untuk voucher maupun langganan store yang sedang aktif — tidak bisa dibatalkan.</span>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeConfirm()">Batal</button>
        <button type="button" class="hds-btn-danger" [disabled]="isSaving" (click)="confirmRevoke()">
          <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i> Ya, Cabut Premium</button>
      </div>
    </ng-container>

  </div>
</div>

<!-- manual premium: grant (new) or extend (active) by day count -->
<div class="hds-overlay" *ngIf="isPremium" (click)="closePremium()">
  <div class="hds-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-b">
      <h3>{{isPremium.mode == 'grant' ? 'Beri Premium Manual' : 'Perpanjang Premium'}}</h3>
      <p class="hds-sub">
        {{isPremium.mode == 'grant' ? 'Berikan akses premium untuk' : 'Tambahkan masa berlaku premium untuk'}}
        <b>{{isDetail?.name}}</b> tanpa lewat Play Store / App Store.
      </p>
      <div class="vu-days-field">
        <label class="vf-label">Jumlah Hari</label>
        <input type="number" min="1" class="vf-input" [(ngModel)]="isPremium.days" [disabled]="isPremiumSaving">
      </div>
    </div>
    <div class="hds-foot hds-foot-end">
      <button type="button" class="vl-btn-ghost" [disabled]="isPremiumSaving" (click)="closePremium()">Batal</button>
      <button type="button" class="vl-btn-primary" [disabled]="isPremiumSaving || !isPremium.days || isPremium.days <= 0"
              (click)="confirmPremium()">
        <i class="fa fa-spinner fa-spin" *ngIf="isPremiumSaving"></i>
        {{isPremium.mode == 'grant' ? 'Ya, Berikan' : 'Ya, Perpanjang'}}</button>
    </div>
  </div>
</div>

<!-- grant a voucher subscription: pick from available vouchers, then confirm -->
<div class="hds-overlay" *ngIf="isGrant" (click)="closeGrant()">
  <div class="hds-dialog vg-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

    <ng-container *ngIf="isGrant.step == 'pick'">
      <div class="hds-b">
        <h3>Pasangkan Voucher</h3>
        <p class="hds-sub">Pilih voucher yang masih tersedia untuk dipasangkan ke <b>{{isDetail?.name}}</b>.</p>
        <input class="vl-input vg-search" type="search" placeholder="Cari nama atau kode voucher&hellip;"
               aria-label="Cari voucher" [value]="isGrantKeyword"
               (input)="onGrantKeyword($event.target.value)" (keyup.enter)="searchGrant()">
        <div class="vg-list">
          <div class="vg-note" *ngIf="isGrantLoading">Memuat&hellip;</div>
          <ng-container *ngIf="!isGrantLoading">
            <button type="button" class="vg-row" *ngFor="let v of isGrantList" (click)="pickGrant(v)">
              <span class="vg-main">
                <span class="vg-name">{{v.name}}</span>
                <span class="vg-code">{{v.code}}</span>
              </span>
              <span class="vg-meta">
                <span *ngIf="v.type == 0" class="vl-tag unik">Unik</span>
                <span *ngIf="v.type == 1" class="vl-tag masal">Masal</span>
                <span class="vg-days">{{v.expired_day}} hari</span>
                <span class="vg-left" *ngIf="v.type == 1">Sisa {{v.remaining}}</span>
              </span>
            </button>
            <div class="vg-note" *ngIf="!isGrantList.length">Tidak ada voucher tersedia yang cocok.</div>
          </ng-container>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" (click)="closeGrant()">Batal</button>
      </div>
    </ng-container>

    <ng-container *ngIf="isGrant.step == 'confirm'">
      <div class="hds-b">
        <h3>Pasangkan voucher ini?</h3>
        <p class="hds-sub">Periksa kembali sebelum menyimpan.</p>
        <div class="hds-panel">
          <div class="hds-row"><span>Pengguna</span><b>{{isDetail?.name}}</b></div>
          <div class="hds-row"><span>Voucher</span><b>{{isGrant.voucher.name}}</b></div>
          <div class="hds-row"><span>Kode</span><b>{{isGrant.voucher.code}}</b></div>
          <div class="hds-row"><span>Masa aktif</span><b>{{isGrant.voucher.expired_day}} hari</b></div>
          <div class="hds-row"><span>Berakhir</span><b>{{isGrant.voucher.endVw}}</b></div>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" [disabled]="isGrantSaving" (click)="backGrant()">Kembali</button>
        <button type="button" class="vl-btn-primary" [disabled]="isGrantSaving" (click)="confirmGrant()">
          <i class="fa fa-spinner fa-spin" *ngIf="isGrantSaving"></i> Ya, Pasangkan</button>
      </div>
    </ng-container>

  </div>
</div>

<!-- full-size photo viewer: click anywhere or Escape closes -->
<div class="vb-viewer" *ngIf="isViewer" (click)="closeViewer()">
  <img [src]="isViewer" alt="Foto pengguna">
  <button type="button" class="vb-viewer-close" title="Tutup" aria-label="Tutup">&times;</button>
</div>
